import React, { useState, useEffect } from 'react';
import { Box, chakra, SimpleGrid, Stat, StatLabel, StatNumber, useColorModeValue, Flex, Link, VStack, Spinner, Text } from "@chakra-ui/react";
import { GiWatch } from "react-icons/gi";
import { FaUsers } from "react-icons/fa";
import { BiCategory } from "react-icons/bi";
import CommonVars from "../components/CommonVars";
import axios from "axios";

function StatsCard(props) {
    const { title, stat, icon, direct, page } = props;
    return (
        <Box 
            bg={'white'}
            rounded={'lg'}
        >
            <Box
                borderBottomWidth={1}
                borderStyle={'solid'}
                borderColor={'gray.200'}
            >
                <Stat
                    px={{ base: 2, md: 4 }}
                    py={'5'}
                >
                    <Flex justifyContent={'space-between'}>
                        <Box pl={{ base: 2, md: 4 }}>
                            <StatLabel fontWeight={'medium'}>
                                {title}
                            </StatLabel>
                            <StatNumber fontSize={'2xl'} fontWeight={'medium'}>
                                {stat}
                            </StatNumber>
                        </Box>
                        <Box
                            my={'auto'}
                            pr={{base: 2, md: 2}}
                            pl={{base: 2, md: 20}}
                            color={useColorModeValue('gray.800', 'gray.200')}
                            alignContent={'center'}
                        >
                            {icon}
                        </Box>
                    </Flex>
                </Stat>
            </Box>
            <Box 
                align={'center'}
                py={2}
            >
                <Link color={'blue.500'} href={page}>{direct}</Link>
            </Box>
        </Box>
    );
}

function AdminScreen () {
    if (localStorage.getItem('token') === null || JSON.parse(localStorage.getItem('userDetails')).role !== "admin") {
        window.location.replace("/unauthorized");
    }
    const theToken = localStorage.getItem('token');
    // const isAdmin = JSON.parse(localStorage.getItem('userDetails')).role;

    const [totalPdts, setTotalPdts] = useState(0);
    const [totalCats, setTotalCats] = useState(0);
    const [totalUsers, setTotalUsers] = useState(0);
    const [loading, setLoading] = useState(false);

    // access backend to retrieve total products
    const getTotalPdtNum = async () => {
        axios.get(`${CommonVars.API_URL}/products-summary`, { headers: { Authorization: `Bearer ${theToken}` } })
        .then((res) => {
            setTotalPdts(res.data.count);
            setLoading(true);
        })
        .catch((error) => {
            console.log(error);
        });
    }

    // access backend to retrieve total categories
    const getTotalCatNum = async () => {
        axios.get(`${CommonVars.API_URL}/categories-summary`, { headers: { Authorization: `Bearer ${theToken}` } })
        .then((res) => {
            setTotalCats(res.data.count);
            setLoading(true);
        })
        .catch((error) => {
            console.log(error);
        });
    }

    // access backend to retrieve total customers
    const getTotalUsersNum = async () => {
        axios.get(`${CommonVars.API_URL}/totalUsers-summary`, { headers: { Authorization: `Bearer ${theToken}` } })
        .then((res) => {
            setTotalUsers(res.data.count);
            setLoading(true);
        })
        .catch((error) => {
            console.log(error);
        });
    }

    useEffect(() => {
        getTotalPdtNum();
        getTotalCatNum();
        getTotalUsersNum();
    })


    return (
        <Flex 
            minH={'80vh'}
            align={'center'}
            justify={'center'}
            bg={'#F4F4F4'}
        >
            {loading !== true ? 
                <Flex align={'center'} justify={'center'}>
                    <VStack align="center">
                        <Spinner thickness='9px' speed='0.75s' emptyColor='gray.200' color='blue.500' boxSize={24}/>
                        <Text fontSize={18} pt={6}>Loading...</Text>
                    </VStack>
                </Flex> : 
                <Box maxW="7xl" mx={'auto'} pt={6} px={{ base: 2, sm: 12, md: 17 }}>
                    <chakra.h1
                        textAlign={'center'}
                        fontSize={'4xl'}
                        py={10}
                        fontWeight={'bold'}
                    >
                        How is WLD Watches doing?
                    </chakra.h1>
                    <SimpleGrid columns={{ base: 1, md: 3 }} spacing={{ base: 5, lg: 8 }}>
                        <StatsCard title={'We sell'} stat={`${totalPdts} products`} icon={<GiWatch size={'3em'} />} direct={'Add new product'} page={'/admin/add-product'}/>
                        <StatsCard title={'We have'} stat={`${totalCats} categories`} icon={<BiCategory size={'3em'} />} direct={'Add new category'} page={'/admin/add-category'}/>
                        <StatsCard title={'We serve'} stat={`${totalUsers} users`} icon={<FaUsers size={'3em'} />}/>
                    </SimpleGrid>
                </Box>
            }
            
        </Flex>
    );
}

export default AdminScreen;